import React from 'react';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Button,
  Icon,
  Flex,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaHome, FaLock, FaBan } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export const ForbiddenPage = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const iconColor = useColorModeValue('red.500', 'red.400');

  return (
    <Box
      minH="100vh"
      bg={bgColor}
      display="flex"
      alignItems="center"
      justifyContent="center"
      py={10}
    >
      <Container maxW="container.md" centerContent>
        <VStack spacing={8} textAlign="center" px={4}>
          <Flex
            justify="center"
            align="center"
            w="120px"
            h="120px"
            borderRadius="full"
            bg="red.50"
            border="8px solid"
            borderColor="red.100"
            _dark={{
              bg: 'red.900',
              borderColor: 'red.800',
            }}
          >
            <Icon
              as={FaLock}
              w={12}
              h={12}
              color={iconColor}
            />
          </Flex>

          <VStack spacing={4}>
            <Heading
              as="h1"
              size="2xl"
              fontWeight="bold"
              bgGradient="linear(to-r, red.500, red.600)"
              bgClip="text"
            >
              403 - Access Denied
            </Heading>

            <Text fontSize="lg" color={textColor} maxW="md" lineHeight="tall">
              You don't have permission to access this page. This section is exclusively 
              available to Taluka users for administrative purposes.
            </Text>

           
          </VStack>

          <Flex gap={4} wrap="wrap" justify="center">
            {/* <Button
              colorScheme="blue"
              leftIcon={<FaHome />}
              onClick={() => navigate('/')}
              size="lg"
              px={8}
            >
              Go to Homepage
            </Button> */}
            
            <Button
              variant="outline"
              colorScheme="red"
              leftIcon={<FaBan />}
              onClick={() => navigate(-1)}
              size="lg"
              px={8}
            >
              Go Back
            </Button>
          </Flex>
        </VStack>
      </Container>
    </Box>
  );
};

export default ForbiddenPage;